"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const color_1 = __importDefault(require("color"));
exports.darken = (inputColor, amount) => color_1.default(inputColor)
    .darken(amount)
    .hex();
exports.lighten = (inputColor, amount) => color_1.default(inputColor)
    .lighten(amount)
    .hex();
var withClasses_1 = require("./withClasses");
exports.withClasses = withClasses_1.default;
var createPropertiesStyles_1 = require("./createPropertiesStyles");
exports.createPropertiesStyles = createPropertiesStyles_1.createPropertiesStyles;
//# sourceMappingURL=index.js.map